import {
  getRelativeFontSize,
  mediumFont,
  regularFont,
  theme,
} from "../../../../utils/styles";

const currentNakshatraStyles = {
  darkTextField: {
    borderRadius: "0px",
    border: "none",
    background: "transparent",
    boxShadow: "none",
    width: "fit-content",

    ".MuiOutlinedInput-notchedOutline": { border: 0 },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },

    "& .MuiSelect-outlined": {
      border: "none",
      position: "relative",
      padding: "0px 0px",
      color: "#ffffff",
      fontSize: "20px",
      [theme.breakpoints.down("sm")]: {
        padding: "0px 0px",
        fontSize: "16px",
      },

      "&::placeholder": {
        ...mediumFont,
        color: "#ffffffA6",
      },
    },
    "& .MuiSelect-icon": {
      color: "#ffffff",
      top: "calc(50% - 0.6em)",
    },
    "& ..MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },
  },
  datePicker: {
    borderRadius: "10px",
    ".MuiOutlinedInput-notchedOutline": { border: "none" },
    "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      border: "none", // White border on hover
    },
    "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: "none", // White border when focused
    },
    "& .MuiInputBase-input": {
      position: "relative",
      padding: "12px 0px 12px 12px",
      color: "#FFFFFF", // Text color
      borderRadius: "10px",
      fontSize: "16px",
      ...mediumFont,
      [theme.breakpoints.down("sm")]: {
        fontSize: "14px",
        padding: "10px 0px 10px 12px",
      },
      "&::placeholder": {
        fontSize: "16px",
        ...mediumFont, // Adjust as needed
      },
    },
    "& .MuiOutlinedInput-root": {
      background: "transparent", // Background color
      borderRadius: "10px",
      paddingRight: "15px",
      paddingLeft: "0px",
      border: "1px solid rgba(255, 255, 255, 0.3)", // White border
      "&.Mui-focused fieldset": {
        border: "none", // White border when focused
      },
      [theme.breakpoints.down("sm")]: {
        paddingRight: "25px",
        paddingLeft: "8px",
      },
    },
    // Style for the calendar icon
    "& .MuiSvgIcon-root": {
      color: "#FFFFFF", // White color for the calendar icon
    },
  },
  legendDescText: {
    ...regularFont,
    fontSize: getRelativeFontSize(3),
    color: "#ffffffb8",
    display: "list-item",
    listStyle: "square",
    ml: "10px !important",
    [theme.breakpoints.down("sm")]: {
      fontSize: getRelativeFontSize(0),
    },
  },
};

export default currentNakshatraStyles;
